export default "__VITE_ASSET__k5sEdhE1__"